import { locales } from '@/i18n'

// The proxy (src/proxy.ts) rewrites every public URL onto the internal
// /{locale}/{segment} route tree, and `usePathname()` does NOT consistently
// hand back the public shape:
//
//   - request-time render (dev, SSR): the original public path — /authors
//   - PRERENDER (production build):   the internal route  — /en/a/authors
//   - hydrated client:                the public path     — /authors
//
// So anything matching a client-side pathname against public URLs must
// normalize first. Skip it and the prerendered HTML disagrees with the hydrated
// client, and the UI visibly flips on hydration.
//
// Segments carry pageType flags (`a`, `b`, `a-product`, `b-home-disclaimer`),
// hence `[ab]` plus an optional `-suffix`. An already-public path passes
// through untouched — the prefix is simply absent.
const localeAlternation = locales.join('|')
const internalPrefix = new RegExp(`^/(?:${localeAlternation})/[ab](?:-[^/]*)?(?=/|$)`)

/** Internal `/{locale}/{segment}/…` path → the public URL shape, trailing slash dropped. */
export const normalizePathname = (pathname: string): string => {
  const stripped = pathname.replace(internalPrefix, '')
  const noTrailing = stripped.length > 1 ? stripped.replace(/\/+$/, '') : stripped
  return noTrailing === '' ? '/' : noTrailing
}
